module.exports = __webpack_public_path__ + "static/img/18c.088cf1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18c.jpg
// module id = Onhr
// module chunks = 0